
import { useState } from 'react';

export default function AppointmentSection() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    email: '',
    tratamiento: '',
    fecha_preferida: '',
    hora_preferida: '',
    mensaje: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formDataToSend = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d46omot34biqimnfo6q0', {
        method: 'POST',
        body: formDataToSend
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          nombre: '',
          telefono: '',
          email: '',
          tratamiento: '',
          fecha_preferida: '',
          hora_preferida: '',
          mensaje: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Agenda tu Consulta
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Programa tu cita con nuestro especialista en cirugía robótica. 
            Sincronización automática con WhatsApp y Google Calendar.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="rounded-2xl p-8 border" style={{ background: 'linear-gradient(to bottom right, #f0fdfa, white)', borderColor: '#20C6B2' }}>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Información de la Consulta</h3>
              
              <div className="space-y-6">
                <div className="flex items-center">
                  <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4" style={{ backgroundColor: '#20C6B2' }}>
                    <i className="ri-money-dollar-circle-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Consulta Especializada</h4>
                    <p className="text-gray-600">Evaluación completa</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-time-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Duración</h4>
                    <p className="text-gray-600">45-60 minutos</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-xl text-purple-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Ubicación</h4>
                    <p className="text-gray-600">Hospital Real San José Valle Real<br />Consultorio 10B</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-calendar-check-line text-xl text-orange-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900">Horarios</h4>
                    <p className="text-gray-600">Lunes a Viernes: 9:00 AM - 6:00 PM<br />Sábados: 9:00 AM - 2:00 PM</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 rounded-xl text-white" style={{ backgroundColor: '#20C6B2' }}>
                <h4 className="font-semibold mb-2">Integración Digital</h4>
                <div className="flex items-center space-x-4">
                  <i className="ri-whatsapp-line text-2xl"></i>
                  <i className="ri-google-line text-2xl"></i>
                  <i className="ri-calendar-line text-2xl"></i>
                </div>
                <p className="text-white/80 text-sm mt-2">
                  Tu cita se sincroniza automáticamente con WhatsApp y Google Calendar
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
            <form id="agenda-consulta" onSubmit={handleSubmit} data-readdy-form>
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Nombre Completo *
                  </label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm"
                    style={{ 
                      '&:focus': { 
                        outline: 'none', 
                        borderColor: '#20C6B2', 
                        boxShadow: `0 0 0 2px rgba(32, 198, 178, 0.2)` 
                      } 
                    }}
                    placeholder="Tu nombre completo"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Teléfono *
                  </label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm"
                    placeholder="Tu número de teléfono"
                  />
                </div>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm"
                  placeholder="tu@email.com"
                />
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Tratamiento de Interés
                </label>
                <select
                  name="tratamiento"
                  value={formData.tratamiento}
                  onChange={handleChange}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm pr-8"
                >
                  <option value="">Selecciona un tratamiento</option>
                  <option value="cirugia-robotica-prostata">Cirugía Robótica de Próstata</option>
                  <option value="cirugia-robotica-rinon">Cirugía Robótica de Riñón</option>
                  <option value="disfuncion-erectil">Tratamiento Disfunción Eréctil</option>
                  <option value="tratamiento-vph">Tratamiento VPH</option>
                  <option value="cirugia-laser">Cirugía Láser Urológica</option>
                  <option value="cirugia-reconstructiva">Cirugía Reconstructiva</option>
                  <option value="consulta-general">Consulta General</option>
                </select>
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Fecha Preferida
                  </label>
                  <input
                    type="date"
                    name="fecha_preferida"
                    value={formData.fecha_preferida}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm"
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Hora Preferida
                  </label>
                  <select
                    name="hora_preferida"
                    value={formData.hora_preferida}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm pr-8"
                  >
                    <option value="">Selecciona una hora</option>
                    <option value="09:00">9:00 AM</option>
                    <option value="10:00">10:00 AM</option>
                    <option value="11:00">11:00 AM</option>
                    <option value="12:00">12:00 PM</option>
                    <option value="13:00">1:00 PM</option>
                    <option value="14:00">2:00 PM</option>
                    <option value="15:00">3:00 PM</option>
                    <option value="16:00">4:00 PM</option>
                    <option value="17:00">5:00 PM</option>
                  </select>
                </div>
              </div>
              
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Mensaje Adicional
                </label>
                <textarea
                  name="mensaje"
                  value={formData.mensaje}
                  onChange={handleChange}
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm resize-none"
                  placeholder="Describe brevemente tu consulta o síntomas (máximo 500 caracteres)"
                ></textarea>
                <div className="text-right text-xs text-gray-500 mt-1">
                  {formData.mensaje.length}/500 caracteres
                </div>
              </div>
              
              {submitStatus === 'success' && (
                <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center">
                    <i className="ri-check-circle-line text-green-600 mr-2"></i>
                    <span className="text-green-800">¡Cita agendada exitosamente! Te contactaremos pronto.</span>
                  </div>
                </div>
              )}
              
              {submitStatus === 'error' && (
                <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
                  <div className="flex items-center">
                    <i className="ri-error-warning-line text-red-600 mr-2"></i>
                    <span className="text-red-800">Error al enviar. Por favor intenta nuevamente.</span>
                  </div>
                </div>
              )}
              
              <button
                type="submit"
                disabled={isSubmitting || formData.mensaje.length > 500}
                className="w-full text-white py-4 rounded-lg font-semibold hover:opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                style={{ backgroundColor: '#20C6B2' }}
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    Enviando...
                  </>
                ) : (
                  <>
                    <i className="ri-calendar-check-line mr-2"></i>
                    Agendar Consulta
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
